import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import {
  AccountHolder,
  listAndSearchAllAccounts,
  updateAccountHolder,
} from "@rentablo/api/apiv1";
import {
  NetfondsConsentContext,
  NetfondsConsentEvent,
} from "../netfondsConsentSM";

const batchUpdate = async (
  accountHolders: AccountHolder[],
  isSyncEnabled: boolean,
  callback: Sender<NetfondsConsentEvent>
) => {
  const updateAccountHolderWithToken = withToken(updateAccountHolder);
  try {
    for (const accountHolder of accountHolders) {
      if (
        accountHolder.isSyncConsentRequired ||
        accountHolder.isSyncEnabled !== isSyncEnabled
      ) {
        await updateAccountHolderWithToken({
          id: accountHolder.id,
          createOrUpdateAccountHolderParams: {
            isSyncEnabled: isSyncEnabled,
          },
        });
      }
    }

    if (isSyncEnabled) {
      callback({ type: "ACTIVATE" });
      return;
    }

    if (!isSyncEnabled) {
      deactivateOrDeleteCallback(callback);
    }
  } catch (error) {
    callback({
      type: "SOMETHING_WRONG",
      error: error as AxiosApiError,
    });
  }
};

const deactivateOrDeleteCallback = async (
  callback: Sender<NetfondsConsentEvent>
) => {
  const getAccounts = withToken(listAndSearchAllAccounts);
  const accountList = await getAccounts({
    bankConnectionType: ["NETFONDS"],
  });
  callback({
    type: accountList.accounts.length ? "DELETE_ACCOUNTS" : "DEACTIVATE",
  });
};

export const batchActivate =
  (
    context: NetfondsConsentContext,
    event: NetfondsConsentEvent
  ): InvokeCallback<NetfondsConsentEvent, NetfondsConsentEvent> =>
  (callback) => {
    if (event.type === "BATCH_ACTIVATE") {
      batchUpdate(context.accountHolders, true, callback);
      return;
    }

    throw new Error(`Invalid event type ${event.type}`);
  };

export const batchDeactivate =
  (
    context: NetfondsConsentContext,
    event: NetfondsConsentEvent
  ): InvokeCallback<NetfondsConsentEvent, NetfondsConsentEvent> =>
  (callback) => {
    if (event.type === "BATCH_DEACTIVATE") {
      batchUpdate(context.accountHolders, false, callback);
      return;
    }

    throw new Error(`Invalid event type ${event.type}`);
  };
